import { Card } from "../../ui/CustomCard/CustomCard";
import CustomButton from "../../ui/CustomButton/CustomButton";

const PIN_LENGTH = 6;
const MASKED_PIN = "*".repeat(PIN_LENGTH);

export default function PinSection({ onChangeClick, disabled }) {
  return (
    <Card className="bg-white border-[#e5e7eb] shadow-none">
      <div className="flex items-center justify-between flex-wrap gap-2 p-6">
        <p
          className="text-base font-semibold text-gray-900"
          aria-label="PIN is set"
        >
          PIN:{" "}
          <span className="relative top-0.5 tracking-widest">{MASKED_PIN}</span>
        </p>
        <CustomButton
          radius="xl"
          variant="outline"
          size="sm"
          onClick={onChangeClick}
          disabled={disabled}
        >
          Change PIN
        </CustomButton>
      </div>
    </Card>
  );
}
